import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

type InfoGroupCreateInfoPageProps = {
  url: string;
};

export const InfoGroupCreateInfoPageButton: FC<InfoGroupCreateInfoPageProps> = ({ url }) => (
  <Button
    type="button"
    variant="contained"
    color="primary"
    component={RouterLink}
    to={`${url}/create`}
  >
    Создать инфо. страницу
  </Button>
);
